// services/authService.js
import api from "./api";

export const authService = {
  // Register user
  register: async (userData) => {
    const response = await api.post("/auth/register", userData);
    return response.data;
  },

  // Set PIN (requires register token in header)
  setPin: async (pinData, registerToken) => {
    const response = await api.post("/auth/set-pin", pinData, {
      headers: { Authorization: `Bearer ${registerToken}` },
    });
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post("/auth/login", credentials);
    return response.data;
  },

  logout: async () => {
    const response = await api.post("/auth/logout");
    return response.data;
  },

  refreshToken: async () => {
    const response = await api.post("/auth/refresh");
    return response.data;
  },
};
